import styled from '@emotion/styled';
import {Button, Chip} from '@bosch/react-frok';

export const FilterSelectionWrapper = styled.div`
    min-height: 3rem;
    margin: 1rem 0 1rem;
`;

export const TotalCountContainer = styled.div`
    padding-left: 1rem;
    padding-right: 1rem;
`;

export const ResetChipsButtonContainer = styled.div`
    display: inline;
    text-align: center;
    vertical-align: middle;
`;

export const FilterSortContainer = styled.div`
    text-align: center;
    vertical-align: middle;
`;

export const FiltersContainer = styled.div<{ expanded: boolean }>`
    max-height: ${(props) => (props.expanded ? '100vh' : '0px')};
    opacity: ${(props) => (props.expanded ? 1 : 0)};
    overflow: ${(props) => (props.expanded ? 'visible' : 'hidden')};
    transition: all 0.5s ease-in-out;
`;

export const ActionButton = styled(Button)<{ fontSize: number }>`
    margin: 0;
    min-width: 180px;
    max-width: 240px;
    height: 48px;
    font-size: ${(props) => props.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledChipClickableArea = styled(Chip)`
    .a-chip__close {
        width: 1.4rem;
        height: 1.4rem;
        right: 0.3rem;

        &::before,
        &::after {
            top: 0.25rem;
            right: 0.65rem;
        }
    }
`;

styled(StyledChipClickableArea)`
    margin-top: 0.5rem;
`;

export const ContentWrapper = styled.div`
    flex-wrap: wrap;
    margin: 1rem 2rem 1rem 2rem;
    padding-top: 0.5rem;
`;

export const FiltersContent = styled.div<{ isMobileResolution: boolean }>`
    padding-bottom: 1.5rem;
    display: grid;
    grid-template-columns: ${(props) => props.isMobileResolution ? '2fr 3fr' : '1fr 4fr'};
`;

export const CloseButtonWrapper = styled.div`
    grid-row: 2;
    grid-column: 1/-1;
    text-align: center;
    width: 100%;
`;

export const FilterSortBar = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const FilterSortContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
`;

export const AddBar = styled.div`
    display: flex;
    align-items: flex-end;
`;

export const SearchFieldWrapper = styled.div`
    width: 100%;
`;
